import type { CSSProperties, ReactNode } from 'react';

export interface SwitchProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  label?: ReactNode;
  ariaLabel?: string;
  disabled?: boolean;
  style?: CSSProperties;
}

/** On/off setting that takes effect as a value of the form (active flags). */
export function Switch({ checked, onChange, label, ariaLabel, disabled = false, style }: SwitchProps) {
  const classes = ['fs-switch'];
  if (disabled) classes.push('fs-switch--disabled');
  return (
    <label className={classes.join(' ')} style={style}>
      <input
        type="checkbox"
        role="switch"
        className="fs-visually-hidden"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(event) => onChange?.(event.target.checked)}
      />
      <span className={checked ? 'fs-switch__track fs-switch__track--on' : 'fs-switch__track'} aria-hidden="true">
        <span className="fs-switch__thumb" />
      </span>
      {label ? <span>{label}</span> : null}
    </label>
  );
}
